module.exports = __webpack_public_path__ + "img/30.6.CODm.3fef18ae.png";